import { createApp } from 'vue'
import App from './App.vue'
import background_app from './components/background_app.vue'
import header_app from './components/header_app.vue'
import footer_app from './components/footer_app.vue'

createApp(App).mount('#app')
createApp(background_app).mount('#background_app')
createApp(header_app).mount('#header_app')
createApp(footer_app).mount('#footer_app')
